import { ArrowRight } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";

const STAGES = ["One Property", "Several Parcels", "An Assemblage", "A Development Site", "New Housing"];

export const Development = () => {
  return (
    <section id="development" data-testid="development-section" className="relative bg-[#F4F1EA] py-24 sm:py-32 lg:py-40 scroll-mt-20 overflow-hidden">
      <div className="absolute inset-0 parcel-bg opacity-[0.08] pointer-events-none" aria-hidden="true" />
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <Reveal className="max-w-3xl">
          <Eyebrow>Looking Forward</Eyebrow>
          <h2 className="mt-5 font-display text-4xl sm:text-5xl text-[#111513] leading-[1.12] text-balance">
            What could this property <span className="italic text-[#A77A50]">become?</span>
          </h2>
          <p className="mt-6 text-lg text-[#5C665F] leading-relaxed">
            Our research often follows a path — from a single address to something larger. Each stage begins with
            public records, feasibility work, and conversations with owners.
          </p>
        </Reveal>
        <Reveal delay={0.1}>
          <div className="mt-14 sm:mt-16 overflow-hidden">
            <img
              src="/images/townhomes-rainy.webp"
              alt="Modern townhomes set into a forested Pacific Northwest landscape in the rain"
              loading="lazy"
              className="w-full aspect-[16/10] sm:aspect-[21/9] object-cover transition-transform duration-[1200ms] ease-out hover:scale-[1.025]"
            />
          </div>
        </Reveal>
        <Reveal delay={0.15}>
          <div className="mt-12 flex overflow-x-auto pb-4 -mx-4 px-4 sm:mx-0 sm:px-0" role="list">
            {STAGES.map((s, i) => (
              <div key={s} className="flex items-start shrink-0" role="listitem" data-testid={`development-stage-${i}`}>
                <div className="min-w-[190px] sm:min-w-[210px] border-t-2 border-[#D9D6CE] pt-6 pr-6 hover:border-[#A77A50] transition-colors duration-300">
                  <span className="font-display text-4xl sm:text-5xl text-[#A77A50]" aria-hidden="true">
                    0{i + 1}
                  </span>
                  <p className="mt-3 font-display text-xl sm:text-2xl text-[#111513] leading-snug">{s}</p>
                </div>
                {i < STAGES.length - 1 && (
                  <ArrowRight className="w-5 h-5 mt-9 mx-2 text-[#718477] shrink-0" aria-hidden="true" />
                )}
              </div>
            ))}
          </div>
        </Reveal>
        <Reveal delay={0.25}>
          <p className="mt-10 text-sm text-[#718477] leading-relaxed max-w-2xl">
            Every stage depends on zoning, access, site conditions, and applicable approvals. Nothing here implies
            that any specific project is approved, secured, or underway — it describes how we think.
          </p>
        </Reveal>
      </div>
    </section>
  );
};
